<script setup lang="ts">
import QuestionCircle from '~icons/cue-regular/question-circle'
import Icon from '../icon/Icon.vue'
import Tooltip from '../tooltip/Tooltip.vue'

withDefaults(
  defineProps<{
    label?: string
    disabled?: boolean
    maxWidth?: string
    size?: string
  }>(),
  {
    label: '',
    disabled: false,
    maxWidth: '320px',
    size: '16',
  },
)
</script>

<template lang="pug">
Tooltip(v-if="label" :label="label" :disabled="disabled" :maxWidth="maxWidth")
  Icon.icon(:class="{ disabled, [`s-${size}`]: true }" :name="QuestionCircle")
</template>

<style scoped>
.icon {
  color: var(--cue-content-neutral-tertiary);

  &.disabled {
    color: var(--cue-content-neutral-disabled);
  }

  :not(.disabled) {
    --uno: cursor-pointer;
  }
}
</style>
